import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHttp } from 'shared/providers/provide-http';
import { BackendFilterModel, TableDataResponse } from 'types/backend';

interface IUseFetchProps {
    cacheName?: string;
    queryPath: string;
    filtersApplied?: BackendFilterModel;
}

export function useFetchTableData<T>({
    cacheName = 'genericfetchtable',
    queryPath,
    filtersApplied
}: IUseFetchProps) {
    const { enqueueSnackbar } = useSnackbar();
    const http = useHttp();

    const response = useQuery<TableDataResponse<T>, Error>(
        [cacheName, filtersApplied],
        async () => {
            const { data } = await http.post(`api/${queryPath}`, {
                FilterModel: filtersApplied,
                SortModel: [],
            });
            return data || []; 
        },
        {
            onError: (error) => enqueueSnackbar(error.message, { variant: 'error' }),
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    );
  return response;
}
